import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user) {
        if (user.temPermissao(['admin_rdo'])) {
            can('manage', 'RDO')
        }
        if (user.temPermissao(['rdo_by_obra'])) {
            can('read', 'RDO', {
                obra: { $in: user.obra }
            });
        }
        if (user.temPermissao(['site_manager'])) {
            can(['create', 'read', 'update'], 'RDO', {
                'siteManager.mail': { $eq: user.email }
            });
        }
        if (user.temPermissao(['site_manager'])) {
            can(['create', 'read', 'update'], 'RDO', {
                'siteManagerSuplente.mail': { $eq: user.email }
            });
        }
        if (user.temPermissao(['planejamento'])) {
            can(['config', 'read', 'data_planejada'], 'RDO');
        }
    }

    return build()
}